"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
require("./style.sass");
var ImagePicker = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t, handleImageChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newFile, file, fileUrl, thumbUrl, name_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newFile = e.target.files[0];
                    if (!(props.id === 'video')) return [3 /*break*/, 2];
                    file = e.target.files[0];
                    fileUrl = URL.createObjectURL(file);
                    return [4 /*yield*/, getThumbnailForVideo(fileUrl)];
                case 1:
                    thumbUrl = _a.sent();
                    name_1 = newFile.name.split('.')[0];
                    urltoFile(thumbUrl, "".concat(name_1, ".png"), 'image/png').then(function (files) {
                        props.imagechange(newFile, files);
                    });
                    return [3 /*break*/, 3];
                case 2:
                    props.imagechange(newFile);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    function urltoFile(url, filename, mimeType) {
        return __awaiter(this, void 0, void 0, function () {
            var res, buf;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.arrayBuffer()];
                    case 2:
                        buf = _a.sent();
                        return [2 /*return*/, new File([buf], filename, { type: mimeType })];
                }
            });
        });
    }
    function getThumbnailForVideo(videoUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var video, canvas, imageUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        video = document.createElement('video');
                        canvas = document.createElement('canvas');
                        video.style.display = 'none';
                        canvas.style.display = 'none';
                        // Trigger video load
                        return [4 /*yield*/, new Promise(function (resolve) {
                                video.addEventListener('loadedmetadata', function () {
                                    video.width = video.videoWidth;
                                    video.height = video.videoHeight;
                                    canvas.width = video.videoWidth;
                                    canvas.height = video.videoHeight;
                                    // Seek the video to 25%
                                    video.currentTime = video.duration * 0.2;
                                });
                                video.addEventListener('seeked', function () { return resolve(); });
                                video.src = videoUrl;
                            })];
                    case 1:
                        // Trigger video load
                        _a.sent();
                        // Draw the thumbnailz
                        canvas
                            .getContext('2d')
                            .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
                        imageUrl = canvas.toDataURL('image/png');
                        return [2 /*return*/, imageUrl];
                }
            });
        });
    }
    return (react_1.default.createElement("div", { style: {
            margin: '0.31rem 0px',
            display: 'flex',
            flex: '1 1 0%',
            width: '100%',
            flexDirection: 'column',
        } },
        react_1.default.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flex: 1,
                flexWrap: 'wrap',
                margin: '0.4375rem',
            } },
            react_1.default.createElement("label", { className: 'file-label' }, props.label),
            react_1.default.createElement("label", { className: 'file' },
                react_1.default.createElement("span", { className: 'file-custom', "data-after-content": t('browse'), "data-before-content": props.fileName &&
                        props.fileName[props.id] &&
                        props.fileName[props.id] !== ''
                        ? props.haveSub
                            ? props.fileName[props.id][props.haveSub]
                            : props.fileName[props.id]
                        : t('choose_file') },
                    react_1.default.createElement("input", { accept: props.mediatype === 'image'
                            ? 'image/*'
                            : props.mediatype === 'video'
                                ? 'video/*'
                                : 'image/*, video/*', "aria-label": 'File browser example', id: props.id, onChange: function (e) { return handleImageChange(e); }, ref: props.imgref, 
                        // {...props}
                        type: 'file' }))))));
};
exports.default = ImagePicker;
